export default function(options) {
    if (this.text == Beef.MiniMenu.divider.text) return options.fn(this);
    else return options.inverse(this);
}

